import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useEffect, useState } from 'react';
import { Button, Loading, Toolbar, useDataProvider } from 'react-admin';
import { LANG, useContentLangContext } from 'utils/providers/ContentLangProvider';
import { Search, SearchIconWrapper, StyledInputBase } from '../../common/Search';
import { useLinkInputContext } from '../LinkInput/LinkInputProvider';
import { NestedChoices } from '../LinkInput/types';
import LinkInputModalDialogList from './LinkInputModalDialogList';

interface LinkInputModalDialogProps {

}

const LinkInputModalDialog = (props: LinkInputModalDialogProps) => {
  const { links, link, setLink, setLinkChoices } = useLinkInputContext();
  const { lang, setLang } = useContentLangContext();
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [choices, setChoices] = useState<NestedChoices>([]);
  const dp = useDataProvider();

  useEffect(() => {
    if (link) {
      setLoading(true);
      link.cb(dp).then(f => {
        setLinkChoices(f);
        setChoices(f);
        setLoading(false);
      });
    }
  }, [link, dp, setLinkChoices]);

  useEffect(() => {
    if (null === link && links.length > 0) {
      setLink(links[0]);
    }
  }, [links, link, setLink]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{ width: '100%', height: '90vh' }}
    >
      <Toolbar>
        <ToggleButtonGroup value={lang} exclusive onChange={(_evt: React.MouseEvent<HTMLElement>, newLang: LANG) => setLang(newLang)}>
          <ToggleButton value="en">EN</ToggleButton>
          <ToggleButton value="tc">繁</ToggleButton>
          <ToggleButton value="sc">簡</ToggleButton>
        </ToggleButtonGroup>
        <span style={{ width: '10px' }}></span>
        {links.map((link) => (
          <Button key={link.id} variant="contained" onClick={() => setLink(link)} label={link.label} />
        ))}
        <span style={{ flex: 1 }}></span>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </Search>
      </Toolbar>
      <Paper sx={{ height: 'calc(90vh - 64px - 64px)', overflowY: 'scroll' }}>
        {link && <LinkInputModalDialogList {...props} link={link} choices={choices} search={search} />}
      </Paper>
    </Box>
  )
}

export default LinkInputModalDialog;